import Layout from '$merchantComponent/layout/home'
import InfoManager from './info-manager';
import ImageManager from './image-manager';
import BusinessManager from './business-manager';
import FinanceManager from './finance-manager';
import AccountManger from './account-manager'
export default commomImport => [{
  path: `/store-manager`,
  name: 'StoreManager',
  component: Layout,
  meta: {
    title: 'store.storeManager', icon: 'el-icon-s-shop'
  },
  children: [
    ...InfoManager(commomImport),
    ...ImageManager(commomImport),
    ...BusinessManager(commomImport),
    ...FinanceManager(commomImport),
    ...AccountManger(commomImport)
  ]
}];
